@import (reference) '../../../../constants/spacing.module.less';

.container {
  width: 100%;
}

.dropdown-menu {
  display: block;
  margin-top: @space-4;
  height: 32px;
  width: 100%;

  // needs to be nested to beat specificity of internal dropdown-menu-toggler styles
  .dropdown-toggler {
    padding: @space-4 @space-8;
  }
}

.month-input {
  border: 0;
  padding: 0;
  height: 22px;
}
